import { Check } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";
import { scrollToId } from "@/lib/scroll";

const includes = [
  "VIBE micro-jet applicator + charging base",
  "GAZE app with unlimited AI skin scans",
  "Starter set of 3 DOSE cartridges",
  "9-patent closed-loop technology",
  "2-year hardware warranty",
];

const scrollToWaitlist = () => scrollToId("#waitlist");

export const Pricing = () => (
  <section id="pricing" className="relative py-28 md:py-40 scroll-mt-24">
    <div className="pointer-events-none absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] halo" />
    <div className="relative mx-auto max-w-[1400px] px-6 md:px-10">
      <div className="text-center mb-16">
        <Reveal>
          <p className="overline mb-5">Reserve yours</p>
          <h2 className="font-serif font-light text-5xl md:text-7xl leading-[0.95] tracking-[-0.02em]">
            One device. Endless personalization.
          </h2>
        </Reveal>
      </div>

      <Reveal delay={0.1}>
        <div className="mx-auto max-w-xl rounded-2xl border border-white/15 bg-card/70 backdrop-blur-xl p-10 md:p-14 relative overflow-hidden">
          <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-primary to-transparent" />
          <div className="flex items-baseline gap-3">
            <span className="font-serif text-7xl md:text-8xl leading-none">$279</span>
            <span className="font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground pb-3">
              one-time
            </span>
          </div>
          <p className="mt-3 text-sm text-muted-foreground">
            DOSE cartridge subscription from <span className="text-foreground">$29/mo</span> — pause or cancel anytime.
          </p>

          <ul className="mt-10 space-y-4">
            {includes.map((it) => (
              <li key={it} className="flex items-start gap-3 text-sm">
                <Check className="w-4 h-4 text-primary mt-0.5 shrink-0" strokeWidth={2} />
                <span className="text-foreground/90">{it}</span>
              </li>
            ))}
          </ul>

          <button
            data-testid="pricing-waitlist-button"
            onClick={scrollToWaitlist}
            className="group mt-12 w-full inline-flex items-center justify-center gap-3 rounded-full bg-accent px-8 py-4 text-accent-foreground text-sm font-medium hover:bg-white transition-all duration-300"
          >
            Reserve early access
            <span className="transition-transform duration-300 group-hover:translate-x-1.5">→</span>
          </button>
          <p className="mt-4 text-center font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
            No payment today · Priority shipping at launch
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);
